import { AccommodationAddressInput, Address, BillingAddressInput } from '../../gql/graphql';

// an address is valid if it exists and every field except id and line2 is populated
function isValidAddress(address: Address | AccommodationAddressInput | null | undefined): boolean {
  return !!address && !!address.city && !!address.line1 && !!address.state && !!address.zip;
}

// nullifyLine2 turns line2 into null if it was an empty string. This is to comply with aes validation
function nullifyLine2(
  address: Address | AccommodationAddressInput | BillingAddressInput | null | undefined,
): Address | AccommodationAddressInput | BillingAddressInput | null | undefined {
  if (address?.line2 === '') address.line2 = null;
  return address;
}

export { isValidAddress, nullifyLine2 };
